export const SORT_URL_SEARCH_PARAM = 'sort';

export const SORT_ORDER = {
  MOST_MATCHED: 'most_matched',
  RECENT: 'recent',
};

export const URL_QUERY_PARAM_BY_SORT_ORDER = {
  [SORT_ORDER.MOST_MATCHED]: null,
  [SORT_ORDER.RECENT]: 'recent',
};

export const HEADER_ACTIONS = {
  CHANGE_MATCHES_SORT_ORDER: 'CHANGE_MATCHES_SORT_ORDER',
  DISPLAY_MATCHES_ON_MAP: 'DISPLAY_MATCHES_ON_MAP',
  SHARE_MATCHES_WITH_DOCTOR: 'SHARE_MATCHES_WITH_DOCTOR',
  DOWNLOAD_MATCHES_PDF: 'DOWNLOAD_MATCHES_PDF',
};
